<template>
  <div class="semesters">
    <div class="bg-scroll bg-center bg-cover semesters-splash">
      <h1 class="is-size-1 has-text-white font-second--bold">
        All Semesters
      </h1>
    </div>
    <div class="semester-select">
      <div class="tabs">
        <ul>
          <li
            class=""
            :class="{ 'is-active': 'Overview' === activeTab }"
            @click="activeTab = 'Overview'"
          >
            <a>
              Overview
            </a>
          </li>
          <li
            class="active"
            :class="{ 'is-active': s === activeTab }"
            v-for="(s, si) in Object.keys(semesters)"
            :key="si"
            @click="activeTab = s"
          >
            <a>
              {{ s }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="activeTab === 'Overview'" class="courses-overview">
      <div class="courses-title level font-second">
        <h1 class="level-left is-size-3 is-size-4-mobile">Overview</h1>
        <div
          class="overview-button is-size-7 rf-button font-second level-right"
        >
          <a :href="baseURL" target="_blank">
            Download Overview
          </a>
        </div>
      </div>
      <div class="description">
        <p class="subtitle font-main is-size-5 is-size-6-mobile">
          These courses are for seminary students, pastors, Sunday School
          teachers, home schoolers, or anyone interested in studying the Bible.
          They are great for review or continuing your Bible education. Every
          class is recorded so they can be watched at a later time.
        </p>
        <p class="subtitle font-main is-size-5 is-size-6-mobile">
          These are "audit" classes, so there are no tests or papers. Moreover,
          there is no academic credit, though you may be able to pass out of
          Hebrew classes at some institutions if you do the work. To get the
          most out of the classes, you should do the Hebrew work or assigned
          readings.
        </p>
        <p class="subtitle font-main is-size-5 is-size-6-mobile">
          The material is seminary-level, but the prices are much lower than the
          standard seminary price: $250 for one course (not credit hour), $500
          for two courses. and $750 for four courses. Church pricing is available as well. Of course, classes need
          to be sufficiently large to make.
        </p>
        <p class="subtitle font-main is-size-5 is-size-6-mobile">
          The English Bible classes are for all ages, from teenagers and above.
          The same is true of the Hebrew classes, but the content and mastery of
          the language will increase in difficulty with age. These classes are
          for helping Christians in the church or for their spiritual
          edification not for the academy, though the classes may help those in
          the academy or who later plan to go to the academy.
        </p>
      </div>
    </div>
    <div v-else class="semesters-list">
      <div class="semester">
        <h1 class="title font-main">{{ activeTab }}</h1>
        <div class="courses">
          <div
            class="course columns"
            v-for="(c, ci) in semesters[activeTab]"
            :key="ci"
          >
            <p class="course-title font-second column is-2">
              {{ c.title }}
            </p>
            <div class="course-description font-main column is-8">
              {{ c.description }}
            </div>
            <p class="syllabus column is-2 rf-button">
              <a :href="syllabusURL(activeTab, c.syllabus)" target="_blank">
                <span class="icon is-large">
                  <i class="fas fa-university fa-lg" />
                </span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import semesters from './semester.js'

export default {
  name: 'Semesters',
  data() {
    return {
      activeTab: 'Overview',
      semesters: semesters,
      baseURL: 'http://syllabus.russelltfuller.com/Overview.pdf',
    }
  },
  methods: {
    syllabusURL: (semester, filename) => {
      return `http://syllabus.russelltfuller.com/${semester
        .toLowerCase()
        .split(' ')
        .join('')}/${filename}`
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/_vars.scss';
@import '@/assets/css/_colors.scss';

.semesters {
  height: 100vh;

  & > .semester-select {
    padding: 0.5em 1em;
  }
  & > .semesters-list {
    padding: 2em;

    & > .semester {
      & > .courses {
        padding: 0 2em;
        & > .course {
          border: 1px solid $primary;
          &:not(:last-child) {
            border-bottom: none;
          }
          & > .syllabus {
            text-align: right;
          }
        }
      }
    }
  }
}
.courses-overview {
  padding: 2em;
  margin-bottom: 5em;
  & > .description {
    padding: 0.5em 2em;
  }
}
.semesters-splash {
  background-image: $mask-dark, url('../assets/Aleppo.jpg');
  position: relative;
  overflow-y: visible;
  height: 20em;
  & > h1 {
    position: absolute;
    top: 50%;
    left: 10%;
  }
}
</style>
